import { send } from 'server';

export const setFraudRequestStatus = () => send({
    ID : 35677,
    eventType : 'selfExclusionAdded',
    description: 'Check Fraud',
    responses: [35678, 35679]
});

export const setSelfExclusionStatus = (data) => send({
    ID: 35631,
    description: 'Self Exclusion',
    responses: [35632, 35633],
    product: data.product,
    period: data.period,
    endType: 'automatic'
});
